export default [
  {
    code: "en",
    name: "English",
    pricingTable: {
      description: "DESCRIPTION",
      quantity: "QUANTITY",
      rate: "RATE",
      discount: "DISC.",
      total: "PRICE",
      totalAndTaxes: { subtotal: "SUBTOTAL", total: "TOTAL" },
    },
  },
  {
    code: "es",
    name: "Español",
    pricingTable: {
      description: "DESCRIPCIÓN",
      quantity: "CANTIDAD",
      rate: "PRECIO UND.",
      discount: "DTO.",
      total: "TOTAL",
      totalAndTaxes: { subtotal: "SUBTOTAL", total: "TOTAL" },
    },
  },
];
